<article class="player-card">
  <header class="player-card__header">
    <div class="player-card__avatar" aria-hidden="true">{{ initials() }}</div>
    <div class="player-card__identity">
      <h3 class="player-card__alias">{{ card().alias }}</h3>
      <span class="player-card__location">
        <app-icon [icon]="mapPinIcon" [size]="12" aria-hidden="true" />
        {{ location() }}
      </span>
    </div>
  </header>

  @if (card().games.length > 0) {
    <ul class="player-card__games">
      @for (game of card().games; track game.slug) {
        <li class="player-card__game" [style.--pill-color]="game.accent_color">{{ game.name }}</li>
      }
    </ul>
  }

  @if (bio()) {
    <!-- Texto plano: interpolación, nunca [innerHTML] (§5.6 4 bis). -->
    <p class="player-card__bio">{{ bio() }}</p>
  }

  <footer class="player-card__footer">
    @if (since()) {
      <span class="player-card__since">{{ since() }}</span>
    }
    @switch (card().request_state) {
      @case ('sent') {
        <span class="player-card__state">{{ copy.sent }}</span>
      }
      @case ('received') {
        <a class="player-card__link" [routerLink]="profilePath">{{ copy.received }}</a>
      }
      @case ('connected') {
        <a class="player-card__link" [routerLink]="profilePath">{{ copy.connected }}</a>
      }
      @default {
        <button
          type="button"
          class="player-card__cta"
          [disabled]="!inviteEnabled()"
          (click)="onInvite()"
        >
          {{ copy.invite }}
        </button>
      }
    }
  </footer>
</article>
